<template>
    <div class="domainsPopup">
        <ValidationObserver ref="form" v-slot="{handleSubmit}">
            <vs-row>
                <vs-col vs-w="6" v-if="user.group === 2">
                    <div class="ml-2 mr-2">
                        <ValidationProvider vid="team_id" :name="$t('global.Teams')" rules="required"
                                            v-slot="{ errors }">
                            <label class="text-sm opacity-75">{{ $t('global.Teams') }}</label>
                            <v-select
                                :options="teams"
                                :reduce="item => item.id"
                                label="name"
                                :clearable="false"
                                :placeholder="$t('global.Teams')"
                                autocomplete
                                v-model="select.team_id"
                                appendToBody
                                @option:selected="selectTeam"
                                @option:deselected="selectTeam"
                                :calculate-position="withPopper"
                            />
                            <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                        </ValidationProvider>
                    </div>
                </vs-col>
                <vs-col :vs-w="user.group === 2 ? 6 : 12">
                    <div class="ml-2 mr-2">
                        <ValidationProvider vid="hash" :name="$t('global.Affiliates')" rules="required"
                                            v-slot="{ errors }">
                            <label class="text-sm opacity-75">{{ $t('global.Affiliates') }}</label>
                            <v-select
                                :options="affiliates"
                                :reduce="item => item.hash"
                                label="name"
                                :clearable="false"
                                :placeholder="$t('global.Affiliates')"
                                autocomplete
                                v-model="select.hash"
                                appendToBody
                                :calculate-position="withPopper"
                            />
                            <p v-for="(error, index) of errors" :key="index" class="text-danger text-xs">{{ error }}</p>
                        </ValidationProvider>
                    </div>
                </vs-col>
                <vs-col vs-w="12" v-if="popupData.data && popupData.data.length">
                    <div class="m-2">
                        <div class="text-sm opacity-75 mb-4">{{ $t('modals.Companies_Removed') }}</div>
                    </div>
                </vs-col>
                <vs-col vs-w="12" v-if="popupData.data && popupData.data.length">
                    <div class="m-2">
                        <vst-table
                            stripe
                            :all-items="popupData.data.length"
                            :data-table="popupData.data"
                            :heads="heads"
                            :items-pagination="[10, 15, 20]"
                            :view-limit="10"
                            :pagination="false"
                            :panel="false"
                        ></vst-table>
                    </div>
                </vs-col>
                <vs-col vs-w="12" class="text-right mt-5">
                    <div class="m-2">
                        <vs-button @click="handleSubmit(send)" color="success" type="filled">{{
                                $t('buttons.Transfer')
                            }}
                        </vs-button>
                    </div>
                </vs-col>
            </vs-row>
        </ValidationObserver>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import send from '@/utils/fetch'
import ErrorHandler from '@/utils/errorHandler'
import EventBus from '@/store/eventBus'
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {vSelectPosition} from "@/utils/mixins";

export default {
    props: ['popupData', 'popupType', 'popupButton'],
    mixins: [vSelectPosition],
    data() {
        return {
            teamsList: [],
            affiliateList: [],
            select: {},
            heads: [
                {
                    name: 'global.Campaign',
                    key: 'campaign_name',
                    value: 'campaign_name',
                    display: true
                },
                {
                    name: 'global.Offer',
                    key: 'offer_name',
                    value: 'offer_name',
                    display: true
                }
            ]
        }
    },

    components: {
        ValidationProvider,
        ValidationObserver,
        vSelect
    },

    computed: {
        user() {
            return this.$store.getters.userState
        },

        teams() {
            return this.teamsList
        },

        affiliates() {
            return this.affiliateList
        }
    },

    methods: {
        async get(uri) {
            try {
                return await send(uri, 'GET').then(response => response.data.result)
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        selectTeam(data) {
            if (data) {
                this.$set(this.select, 'hash', '')

                this.affiliateList = data.users
                    .filter(user => user.is_active)
                    .filter(user => user.hash !== this.popupData.affiliate_hash)
            }
        },

        async send() {
            try {
                this.select.id = this.popupData.domain_id
                if (this.user.group < 2) this.select.team_id = this.user.team_id

                await send(global.$url.domains.update, 'POST', {data: this.select})
                EventBus.$emit('getDomains')
                EventBus.$emit('emitPopupEvent', {type: 'close'})
            } catch (error) {
                if (error.response) {
                    const response = error.response.data.result
                    this.$refs.form.setErrors(this.$errors(response))
                }
                new ErrorHandler(error).send
            }
        }
    },

    async mounted() {
        try {
            this.teamsList = await this.get(this.$url.team.get)
            if (this.user.group < 2 && this.teamsList) {
                const team = this.teamsList.find(team => team.id === this.user.team_id)
                if (team) {
                    this.selectTeam(team)
                }
            }

            this.$store.commit('UPDATE_LOADER_STATE', false)
        } catch (e) {
            this.$store.commit('UPDATE_LOADER_STATE_SET_ERROR', true)
            new ErrorHandler(e).send
        }
    }
}
</script>

<style lang="scss">
.domainsPopup {
    .vs-con-tbody {
        padding: 0 !important;
        border: none !important;

        .vs-table--td, .tr-values {
            border: none !important;
        }
    }
}
</style>
